import { propagateQueryToExternalLinks, urlIsExternal } from './propagateQueryParams';

// Add key: value to replace href with new path on FE
const SAFE_HREF_REPLACEMENT = {};

export const safeNavigationHref = (href: string): string => {
  if (typeof window === 'undefined') return href;

  // Skip href replacement for external URLs
  if (urlIsExternal(href)) {
    return propagateQueryToExternalLinks(href);
  }

  // Handle absolute URLs by extracting the pathname
  let pathToCheck = href;
  if (href.startsWith('http://') || href.startsWith('https://')) {
    try {
      const url = new URL(href);
      pathToCheck = url.pathname;
    } catch (error) {
      // If URL parsing fails, use the original href
      pathToCheck = href;
    }
  }

  // Normalize path by removing trailing slash for consistent matching
  const normalizedPath = pathToCheck.replace(/\/$/, '');
  const replacementPath = SAFE_HREF_REPLACEMENT[normalizedPath as keyof typeof SAFE_HREF_REPLACEMENT];

  if (replacementPath) {
    // If it was an absolute URL, construct the new absolute URL
    if (href.startsWith('http://') || href.startsWith('https://')) {
      try {
        const url = new URL(href);
        url.pathname = replacementPath;
        return propagateQueryToExternalLinks(url.toString());
      } catch (error) {
        // If URL construction fails, fall back to relative replacement
        return propagateQueryToExternalLinks(replacementPath);
      }
    } else {
      // For relative URLs, use the replacement directly
      return propagateQueryToExternalLinks(replacementPath);
    }
  }

  return propagateQueryToExternalLinks(href);
};
